import React from 'react';

import {MainLayout} from 'widgets/layout';
import {UserReports} from 'features/userReports';

const UserReportsPage: React.FC = () => {

    return (
        <MainLayout>
            <UserReports />
        </MainLayout>
    );
};

export default UserReportsPage;
